import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ManagementFocus } from '@root/api';
import { useTranslation } from '@root/app/shared/hooks/useTranslation';
import {
    focusDescriptionKey,
    focusNameKey,
    focusRecommendationKey
} from '@root/app/shared/utils/managementFocus.utils';
import HfFocusIcon from './HfFocusIcon';

interface HfFocusOptionLabelProps {
    focus: ManagementFocus;
}

/* A focus as an option of a focus select: icon, name, what it means and when it's recommended. */
const HfFocusOptionLabel: React.FC<HfFocusOptionLabelProps> = ({ focus }) => {
    const { t } = useTranslation();
    return (
        <Stack direction='row' spacing={1.5} alignItems='flex-start'>
            <HfFocusIcon focus={focus} size={28} />
            <Stack spacing={0}>
                <Typography variant='body3'>{t(focusNameKey(focus))}</Typography>
                <Typography variant='caption' color='text.secondary' sx={{ whiteSpace: 'normal' }}>
                    {t(focusDescriptionKey(focus))}
                </Typography>
                <Typography variant='caption' color='primary' sx={{ whiteSpace: 'normal' }}>
                    {t(focusRecommendationKey(focus))}
                </Typography>
            </Stack>
        </Stack>
    );
};

export default HfFocusOptionLabel;
